// extracted by mini-css-extract-plugin
export default {"content":"BankAccounts_content__GnaWc","fields":"BankAccounts_fields__QBT3H"};